// Generated by genversion.
export const version = '4.39.0';
